import React from 'react';
import { Video, Star, Handshake, Calendar } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  video: Video,
  star: Star,
  handshake: Handshake,
  calendar: Calendar
};

const Services = () => {
  return (
    <section className="py-20 bg-[#0F172A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Partnership <span className="text-[#22C55E]">Services</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            Flexible collaboration options tailored to your brand's goals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group bg-[#0A0F0D] border border-[#22C55E]/20 rounded-xl p-8 hover:border-[#22C55E] hover:shadow-lg hover:shadow-[#22C55E]/20 transition-all duration-300 hover:scale-105 animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 p-4 bg-[#22C55E]/10 rounded-lg group-hover:bg-[#22C55E]/20 transition-colors duration-300">
                    <Icon className="h-8 w-8 text-[#22C55E]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#22C55E] transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-[#94A3B8] leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;